<template>
    <div v-show="checkInit">
        <div class="columns is-centered">

            <div class="column is-one-third-widescreen is-two-thirds-tablet">
                <div class="card">
                    <div class="card-content">
                        <div class="site-logo">
                            <img src="/icons/android-chrome-192x192.png" />
                            <p><b>{{title}}</b></p>
                        </div>
                        <div class="mt-4"></div>
                        <div class="field">
                            <label class="label">Username</label>
                            <div class="control">
                                <input class="input" type="text" placeholder="Username" v-model="email">
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Password</label>
                            <div class="control">
                                <input class="input" type="password" placeholder="Password" v-model="password">
                            </div>
                        </div>

                        <div class="field">
                            <p class="control has-text-centered">
                                <button @click="login()" class="button is-success button-login">
                                    Accedi
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            email: '',
            password: '',

            checkInit: false,
            title: import.meta.env.VITE_TITLE,

            isStaging: false
        }
    },

    methods: {
        login() {
            this.$http.post('/user/login',
            {
                email: this.email,
                password: this.password
            })
            .then(function (response) {
                // handle success
                //console.log(response)
                location.reload()
            })
            .catch(function (error) {
                // handle error
                console.log(error)
                alert('Errore')
            })
        }
    },

    created() {
        if (this.$store.state.user) {
            this.$router.push('/')
        } else {
            this.checkInit = true
        }

        this.isStaging = import.meta.env.VITE_ENV === 'staging'
        if (this.isStaging) {
            document.documentElement.classList.add('has-background-staging')
        } else {
            document.documentElement.classList.add('has-background-primary')
        }
    },

    unmounted() {
        if (this.isStaging) {
            document.documentElement.classList.remove('has-background-staging')
        } else {
            document.documentElement.classList.remove('has-background-primary')
        }
    }
}
</script>

<style lang="scss" scoped>
.site-logo {
    text-align: center;
    img {
        max-height: 80px;
        width: auto;
    }
}

.button-login {
    width: 100%;
    max-width: 150px;
}
</style>